import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    axios.get(`${window.location.origin}/api/check_login.php`, { withCredentials: true })
      .then(res => setIsAuth(res.data.loggedIn))
      .catch(() => setIsAuth(false));
  }, []);

  if (isAuth === null) return null; // oder ein Loader
  return isAuth ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;

